// @flow
import * as React from "react"
import urls from "data/router/urls"
import LogoIcon from "./LogoIcon"
import LogoIconSmall from "./LogoIconSmall"
import LogoIconFull from "./LogoIconFull"
import { StyledLogoLink, StyledLogo } from "./styled"

type Props = {|
  type: "small" | "default" | "full",
  onClick?: Function,
|}

const LogoLink = ({ type, onClick }: Props) => {
  function renderDefaultLogo() {
    if (type === "small") {
      return <LogoIconSmall />
    } else if (type === "default") {
      return <LogoIcon />
    } else if (type === "full") {
      return <LogoIconFull />
    }
  }

  return <StyledLogoLink to={urls.home} onClick={onClick}>
    {renderDefaultLogo()}
  </StyledLogoLink>
}

export default LogoLink



// WEBPACK FOOTER //
// ./src/components/LogoLink/index.js